import angular from "angular";

export class FormHelpersService {

    public setAllFieldsToDirty(form) {
        FormHelpersService.callMethodOnProperty(form, "$setDirty");
    }
    
    public setAllFieldsToPristine(form) {
        FormHelpersService.callMethodOnProperty(form, "$setPristine");
    }

    public getCtrlFormController(formAncestorElementScope, formName) {
        // Dereference any "$ctrl" prefix - the form name will be prefixed with "$ctrl." if the 
        // form is hosted within a template that employs "controllerAs" syntax.  In this case,
        // a property by the name of "$ctrl" is expected to have been automagically added to 
        // the specified scope.
        if (formAncestorElementScope &&
            formName.startsWith("$ctrl.")
        ) {
            const unprefixedFormName = formName.substring("$ctrl.".length, formName.length);

            if (formAncestorElementScope.hasOwnProperty("$ctrl")) {   
                const ctrlScope = formAncestorElementScope["$ctrl"];

                if (ctrlScope.hasOwnProperty(unprefixedFormName)) {
                    return ctrlScope[unprefixedFormName];
                }
            }
        }
        
        return null;
    }
        
    private static callMethodOnProperty(form, methodName) {
        function callMethodOnValue(value, methodName) {
            var method = value[methodName];

            if (angular.isFunction(method)) {
                method();
            }
        }

        for (var prop in form) {
            if (prop[0] != '$') {
                callMethodOnValue(form[prop], methodName);
            }
        }
    }
}